import './Tiles.css'
import TandCfooter from './TandCfooter'

const CutpriceTile = props => {
    //console.log('CutpriceTile props:',props.info)
    const {productUrl,shortDescription,price,custom_title,heading,tnc,symbol,wasPrice,show_bonus_image,overlay_image,pk} = props.info
    const bgImage = props.bgImage
    const productSku = props.sku
    const headerColor = props.headerColor
    const imageUrl = `https://thegoodguys.sirv.com/Content/WhiteTilesSKUs/${productSku}.png`
    let salePrice 
    wasPrice ? salePrice = wasPrice - price : salePrice = null
    return(
        <div className="whitetiles-card__wrapper border-all border-graylight bg-white marg-5 pos-relative" style={{backgroundImage:`url(${bgImage})`,backgroundRepeat: 'no-repeat',backgroundPosition:'center',backgroundSize: 'cover'}}>
            <a href={productUrl} onClick={props.onClick} className="home-white-tile home-white-tile__inner unselectable">
                <section  className="body-tile-copy">
                {custom_title && custom_title !== '' ? <header className="home-white-tile-header marg-top-10" style={headerColor !== '' ? {backgroundColor:`${headerColor}`} : {backgroundColor : 'red'}}>{custom_title}<sup>{symbol}</sup></header> :
                <header className="home-white-tile-header marg-top-10" style={headerColor !== '' ? {backgroundColor:`${headerColor}`} : {backgroundColor : 'red'}}>${salePrice} OFF<sup>{symbol}</sup></header>}
                    <div className="clearfix marg-top-5">
                        <div className="col-xs-6 padd-0 marg-top-0">
                            <img src={imageUrl} alt={heading} className="img-responsive padd-top-5 lazy unselectable" width="278" height="370" draggable="fasle"/>
                        </div>

                        <div className="col-xs-6 padd-left-0 padd-right-0 text-left">
                            <p className="home-white-tile__product-name text-black padd-left-5 text-medium home-white-tile__product-name--reduce-line-height">{shortDescription}</p>
                            <div className="home-white-tile__price-lock-up padd-left-5">
                                <div className="c-cut-price home-white-tile__cut-price">
                                    <span className="c-cut-price__ticket-price">
                                    <img className="c-cut-price__ticket-price-text lazy" src="https://thegoodguys.sirv.com/dm/homepage-acoustic-images/White%20Tiles/ticket-price-text.svg" sizes="63px" width="9" height="24" alt="PRICE OFF" />
                                    <span className="c-cut-price__ticket-price-symbol"><sup>{symbol}</sup></span>
                                    <span className="c-cut-price__old-price">{wasPrice}</span>
                                    </span>
                                    {pk === true ? <span className="c-cut-price__price"><sup>$</sup>{price}<span className="text-size-75">pk</span></span> :<span className="c-cut-price__price"><sup>$</sup>{price}</span>}
                                    
                                    <span className="c-cut-price__after-discount"><img className="lazy img-responsive lz-loading loaded" width="97" height="10" src="https://thegoodguys.sirv.com/dm/homepage-acoustic-images/White%20Tiles/after-discount.svg"/></span>
                                    
                                </div>
                                {show_bonus_image === true ? <div className="home-white-tile__extra-img"><img alt="bonus" className=" img-responsive lazy" src="https://thegoodguys.sirv.com/dm/homepage-acoustic-images/White%20Tiles/bonus-2x.png?q=50" /></div> : <div className="home-white-tile__extra-img-empty"></div>}

                            
                            </div>
                        
                        </div>

                    </div>
                    {overlay_image !== '' ? <img alt="The Good Guys Sale" className="home-white-tile_overlay-img img-responsive lazy pos-absolute" src={overlay_image} width='60'/> : null}
                </section>
                {tnc !== '' ? <TandCfooter info={tnc}/> : null}
            </a>
        </div>
    )
}

export default CutpriceTile